import React, { useEffect, useState } from "react";
import MuiHeader from "../../components/MuiHeader";
import { getECDetails } from "./EcPasswordManager.Api";
import { ToastContainer, toast } from "react-toastify";
import {
  Button,
  FormControl,
  Box,
  Grid,
  IconButton,
  TableHead,
  TableCell,
  Table,
  TableRow,
  TableBody,
  Paper,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const EcePasswordManager = () => {
  const [loading, setLoading] = useState(false);
  const [ecData, setEcData] = useState([]);
  const [visiblePasswords, setVisiblePasswords] = useState({});

  useEffect(() => {
    setLoading(true);
    getECDetails()
      .then((res) => {
        if (res.status === 200) {
          setEcData(res.data);
          setLoading(false);
        } else {
          setEcData([]);
          toast.error("Sorry, couldn't find any data!");
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("The error encountered------->", error);
        toast.error("Sorry, something went wrong. Please try again later.");
        setLoading(false);
      });
  }, []);

  const passwordVisibility = (index) => {
    setVisiblePasswords((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div>
      <MuiHeader header="EC PASSWORD MANAGER" />
      <>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10%",
            }}
          >
            <CircularProgress />
          </div>
        ) : ecData.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sl no.</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Usertype</TableCell>
                <TableCell>Apps allowed</TableCell>
                <TableCell>Userid</TableCell>
                <TableCell style={{ paddingLeft: "80px" }}>Password</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ecData?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{item.username}</TableCell>
                  <TableCell>{item.usertype}</TableCell>

                  {/* Check if accessApps is an array and not empty */}
                  <TableCell>
                    {Array.isArray(item?.accessApps) &&
                    item.accessApps.length > 0 ? (
                      <Box display="flex" flexDirection="column">
                        {item.accessApps.map((app, idx) => (
                          <span key={idx}>◾{app}</span>
                        ))}
                      </Box>
                    ) : (
                      "NA"
                    )}
                  </TableCell>

                  <TableCell>{item.userid}</TableCell>

                  {/* Preventing table shake by maintaining fixed width */}
                  <TableCell>
                    <Box display="flex" alignItems="center">
                      <span
                        style={{ minWidth: "180px", display: "inline-block" }}
                      >
                        {visiblePasswords[index]
                          ? item.password
                          : "*************"}
                      </span>
                      <IconButton onClick={() => passwordVisibility(index)}>
                        {visiblePasswords[index] ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : null}
      </>
      <ToastContainer />
    </div>
  );
};

export default EcePasswordManager;
